.list {
    border-bottom: 1px solid var(--off-white-dk);
    flex-shrink: 0;
    max-height: calc(100% - 25px);
    overflow-y: auto;
}
